<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="PrescriptionTreatment">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            处方治疗列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary"  @click.native="toggleModalAdd">查询治疗项目</el-button>
                    <el-button type="success" :disabled="disabledTreatment" @click="handleTreatment">开始治疗</el-button>
                    <el-button type="info" @click="handleInfo">治疗记录</el-button>
                    <!-- <div style="float:right">
                        <el-input  placeholder="请输入姓名" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-select v-model="medicinerCode" placeholder="请选择医生" clearable style="margin:0 5px">
                            <el-option
                                    v-for="item in medicinerList"
                                    :key="item.medicinerCode"
                                    :label="item.name"
                                    :value="item.medicinerCode">
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="status"
                            style="margin:0 10px;width:200px"
                            placeholder="请选择入住状态">
                            <el-option
                                v-for="item in statusValue"
                                :key="item.val"
                                :label="item.name"
                                :value="item.val">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div> -->
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick' 
                        row-key="code"
                        default-expand-all
                        :tree-props="{children: 'children'}">

                        <el-table-column prop="name" label="名称" width="250"></el-table-column>

                        <el-table-column prop="content" label="治疗内容"></el-table-column>

                        <el-table-column prop="price"  label="治疗费用(元)" width="130"></el-table-column>

                        <el-table-column prop="status" label="治疗状态" width="130">
                            <template slot-scope="scope">
                                <el-tag v-show="scope.row.status==1">待治疗</el-tag>
                                <el-tag type="success" v-show="scope.row.status==2">已治疗</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>

        </div>
        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="showModalInfo=false" v-on:getList="getList"></Info>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Add from "./Add";
    import Info from "./Info";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalInfo:false,
                showModalEdit:false,
                disabledTreatment:true,
                tableData:[],
                totalItems: 0,
                pageSize:20,
                medicinerCode:'',
                patientCode:'',
                consultationTreatmentRelCode:'',
                selectInfo:'',
                serialNumber:'',
                medicinerList:[],
                currentPage:1,
                th:0,
                name:'',
                idCard:'',
                status:-1,
            }
        },
        components:{
            Add,Info
        },
        created(){
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            statusTitle(column){
                if(column==1){
                    return '待治疗'
                }else{
                    return '已治疗'
                }
            },
            rowClick(row){
                this.disabledTreatment=true
                this.selectInfo=row
                if(row.status==1&&!row.children){
                    this.disabledTreatment=false
                }   
            },
            handleInfo(){
                this.showModalInfo = true;
                this.$refs.myInfo.init();
            },
            handleTreatment() {
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"PrescriptionTreatment/Check",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        patientCode:this.patientCode,
                        consultationTreatmentRelCode:this.consultationTreatmentRelCode,
                        prescriptionTreatmentItemCode:this.selectInfo.code,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.$message.error('操作成功')
                        this.disabledTreatment=true
                        this.getTableData()
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
                // this.$refs.myEdit.init(row);
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            getTableData(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'PrescriptionTreatment/getNotCheck',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        serialNumber:this.serialNumber,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data= response.data.data;
                        this.tableData=this.getTable(data)
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getList(data,serialNumber){
                this.serialNumber=serialNumber
                this.tableData=this.getTable(data)
                this.patientCode=data[0].consultationRecordDTO.patientCode
                this.consultationTreatmentRelCode=data[0].consultationTreatmentRelCode
            },
            getTable(data){
                var tableData=[]
                for(var i in data){
                    var obj={
                        code:data[i].prescriptionTreatmentCode,
                        name:data[i].prescriptionTreatment.name,
                        content:data[i].prescriptionTreatment.content,
                        status:data[i].prescriptionTreatment.status,
                        price:'',
                        children:[]
                    }
                    var List=data[i].prescriptionTreatmentItemDTOList
                    var price=0
                    for(var j in List){
                        var obj1={
                            code:List[j].prescriptionTreatmentItemCode,
                            name:List[j].treatmentItem.name,
                            content:List[j].treatmentItem.content,
                            price:List[j].treatmentItem.price,
                            status:List[j].status,
                        }
                        price+=List[j].treatmentItem.price
                        obj.children.push(obj1)
                    }
                    obj.price=price
                    tableData.push(obj)
                }
                return tableData
            }

        }
    }
</script>

<style lang="scss" scoped>
    .PrescriptionTreatment /deep/ .el-table__body tr.current-row>td {
        background-color: rgb(102, 177, 255);;
        color:#fff;
    }
</style>
